// extracted by mini-css-extract-plugin
export var text = "_60-0";